import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Bitmap, Class, Container, drag, Ease, event, Graphics, LoadQueue, Stage, Text, Ticker, Tween } from 'hilojs';

@Component({
    selector: 'pz-map-camera',
    templateUrl: './map-camera.component.html',
    styleUrls: ['./map-camera.component.scss']
})
export class MapCameraComponent {
    @ViewChild('hello', {static: true})
    public content: ElementRef;
    public stage: Stage;
    @Output()
    public cameras: EventEmitter<any[]> = new EventEmitter<any[]>();
    @Input()
    public mapUrl: string;
    public resources = [];
    public queue = new LoadQueue();
    public map: any;
    public mapImg: object;
    public ticker: any;
    public cameraListAll: any[] = [];
    public cameraListEvent: any[] = [];
    public shockWaveList: any[] = [];
    public isEdit: boolean;
    public tips = 0;
    public lines: any[] = [];
    private mapLayer: Container;
    private cameraLayer: Container;
    private waveLayer: Container;
    private lineLayer: Container;
    private tipsLayer: Container;
    private tipWidth = 150;
    private tipHight = 80;
    public positionChanged = false;
    public gloabScale = 1;
    private eventList: any[] = [];

    constructor() {
    }

    init() {
        if (this.stage) {
            this.stage.removeAllChildren();
        }
        this.stage = new Stage({
            renderType: 'canvas',   // æ¸²æç±»å å¯ä»¥æ¯canvas || div
            container: this.content.nativeElement,  // ç¶å®¹å¨
            width: this.content.nativeElement.offsetWidth, // èå°å®½åº¦ï¼è¿éä¹å¯ä»¥ååºå®å¼
            height: this.content.nativeElement.offsetHeight  // èå°é«åº¦ï¼è¿éä¹å¯ä»¥ååºå®å¼
        });
        this.mapLayer = new Container({x: 0, y: 0, width: this.stage.width, height: this.stage.height});
        this.cameraLayer = new Container({x: 0, y: 0, width: this.stage.width, height: this.stage.height});
        this.waveLayer = new Container({x: 0, y: 0, width: this.stage.width, height: this.stage.height});
        this.lineLayer = new Container({x: 0, y: 0, width: this.stage.width, height: this.stage.height});
        this.tipsLayer = new Container({x: 0, y: 0, width: this.stage.width, height: this.stage.height});
        // @ts-ignore
        this.stage.enableDOMEvent([event.POINTER_START, event.POINTER_MOVE, event.POINTER_END]);
        this.stage.addChild(this.mapLayer);
        this.stage.addChild(this.waveLayer);
        this.stage.addChild(this.lineLayer);
        this.stage.addChild(this.tipsLayer);
        this.stage.addChild(this.cameraLayer);
        this.resourcesLoad();
        // å¯å¨è®¡æ¶å¨
        this.ticker = new Ticker(60);
        this.ticker.addTick(Tween);
        this.ticker.addTick(this.stage);
        this.ticker.start(true);
    }

    resourcesLoad() {
        this.resources = [
            {id: 'map', src: this.mapUrl}
        ];
        // @ts-ignore
        this.queue = this.queue.add(this.resources);
        this.queue.on('complete', this.onComplete.bind(this));
        this.queue.start();
    }

    onComplete() {
        this.mapImg = this.queue.getContent('map');
        // @ts-ignore
        this.gloabScale = this.content.nativeElement.offsetHeight / this.mapImg.height;
        this.buildSense();
    }

    buildSense() {
        this.map = new Bitmap({
            image: this.mapImg,
            // @ts-ignore
            scaleX: this.gloabScale,
            // @ts-ignore
            scaleY: this.gloabScale
        }).addTo(this.mapLayer);
    }

    // åå»ºæ­£å¸¸æåå¤´
    createCamera(id, x: number, y: number, status?) {
        if (!this.isEdit) {
            const pos = {
                x: x * this.gloabScale,
                y: y * this.gloabScale
            };
            const camera = new Graphics({width: 26, height: 26, x: pos.x, y: pos.y, id});
            const sta = status ? status : 0;
            const color = ['00fc15', 'fc0a00'];
            if (!(this.cameraListEvent.some(s => s.id === id) || this.cameraListAll.some(s => s.id === id))) {
                camera
                // @ts-ignore
                    .beginRadialGradientFill(13, 13, 0, 13, 13, 6, ['#fff', `#${color[sta]}`], [0, 1])
                    .drawCircle(2, 2, status ? 12 : 6)
                    .endFill().addTo(this.cameraLayer);
            }
            if (status) {
                if (!this.cameraListEvent.some(s => s.id === id)) {
                    this.cameraListEvent = [camera, ...this.cameraListEvent];
                }
            } else {
                if (!this.cameraListAll.some(s => s.id === id)) {
                    this.cameraListAll = [camera, ...this.cameraListAll];
                } else {
                    const targetCamera = this.cameraListAll.find(s => s.id === id);
                    Tween.to(targetCamera, {
                        alpha: 0,
                    }, {
                        duration: 100,
                        stagger: 20,
                        // @ts-ignore
                        ease: Ease.Elastic.EaseIn
                    });
                    this.cameraListAll = this.cameraListAll.filter(t => t.id !== id);
                }
            }
        }
    }

    // åå»ºè­¦åæåå¤´åæç¤ºæ³¢
    createShockWave(id, x, y) {
        const pos = {
            x: x * this.gloabScale,
            y: y * this.gloabScale
        };
        this.createCamera(id, x, y, 1);
        const shockWave = new Graphics({width: 100, height: 100, x: pos.x, y: pos.y, id});
        shockWave.lineStyle(2, '#ff000c')
            .drawCircle(2, 2, 12)
            .endFill()
            .addTo(this.waveLayer);
        if (!this.shockWaveList.some(s => s.id === id)) {
            Tween.to(shockWave,
                {
                    scaleX: 2,
                    scaleY: 2,
                    alpha: 0,
                    x: shockWave.x - 14,
                    y: shockWave.y - 14
                },
                {
                    duration: 800,
                    stagger: 20,
                    loop: true,
                    // @ts-ignore
                    // ease: Ease.Elastic.EaseIn
                });
            this.shockWaveList = [shockWave, ...this.shockWaveList];
        }
    }

    // ç¼è¾æ¨¡å¼
    editCamera() {
        this.isEdit = !this.isEdit;
        if (this.isEdit) {
            this.cameraLayer.removeAllChildren();
            this.cameraListAll.forEach(x => {
                // @ts-ignore
                Class.mix(x, drag);
                x.startDrag();
                x.on('dragEnd', () => {
                    this.positionChanged = true;
                });
                this.cameraLayer.addChild(x);
            });
        } else {
            this.cameraLayer.removeAllChildren();
            const cameras: any[] = [];
            this.cameraListAll.forEach(y => {
                cameras.push({id: y.id, coordinate: `${y.x / this.gloabScale},${y.y / this.gloabScale}`});
            });
            this.cameras.emit(cameras);
            this.cameraListAll = [];
        }
    }

    // éç»tips
    public reDrawTips(id, x, y, time, desc, eventId, showTime) {
        this.eventList.push({id, x, y, time, desc, eventId});
        this.showTips(id, x, y, time, desc);
        setTimeout(() => {
            this.eventList = this.eventList.filter(x => x.eventId !== eventId);
            this.tips = 0;
            this.cameraLayer.removeAllChildren();
            this.waveLayer.removeAllChildren();
            this.lineLayer.removeAllChildren();
            this.tipsLayer.removeAllChildren();
            this.eventList.map(y => {
                this.showTips(y.id, y.x, y.y, y.time, y.desc);
            });
        }, 60 * 1000 * showTime);
    }

    // åå»ºçº¿æ¡
    createLine({x, y}, {endX, endY}) {
        this.lines = [{start: {x, y}, end: {endX, endY}}, ...this.lines];
        const line = new Graphics({
            width: 100, height: 100, x: 0, y: 0
        });
        line.lineStyle(1, '#ff0400')
            .lineTo(endX, endY)
            .lineTo(x + 13, y + 13).endFill().addTo(this.lineLayer);
    }

    // å±ç¤ºæç¤º
    showTips(id, x, y, time, desc) {
        const pos = {
            x: x * this.gloabScale,
            y: y * this.gloabScale
        };
        const count = this.tips;
        const content = new Container({
            x: this.tips < 9 ? this.content.nativeElement.offsetWidth - this.tipWidth - 30 : 30,
            y: this.content.nativeElement.offsetHeight,
            width: this.tipWidth,
            height: this.tipHight,
        });
        new Text({
            text: time,
            lineSpacing: 5,
            font: '11px arial Bold',
            color: '#ffffff',
            maxWidth: this.tipWidth - 10,
            width: this.tipWidth,
            height: this.tipHight,
            x: 32,
            y: 12
        }).addTo(content);
        new Text({
            text: desc,
            maxWidth: this.tipWidth - 10,
            lineSpacing: 0,
            font: '14px arial',
            color: '#ffffff',
            width: 100,
            height: this.tipHight,
            x: 10,
            y: 40
        }).addTo(content);
        const icon = new Bitmap({
            image: 'assets/warning1.png',
        });
        icon.scaleX = 0.5;
        icon.scaleY = 0.5;
        icon.x = 10;
        icon.y = 5;
        icon.addTo(content);
        const line = new Graphics({
            width: 100, height: 100,
            x: 0,
            y: 0
        });
        // @ts-ignore
        line.beginLinearGradientFill(0, 0, 120, 0, ['rgba(79,252,252,1)', 'rgba(79,252,252,0)'], [0.3, 1])
            .drawRect(10, 30, this.tipWidth - 20, 2)
            .endFill()
            .addTo(content);
        const g2 = new Graphics({
            width: 100, height: 100,
            x: 0,
            y: 0
        });
        g2.lineStyle(1, '#ff0400').beginFill('rgba(0,0,0,.2)')
            .drawRoundRect(2, 2, this.tipWidth, this.tipHight, 5)
            .endFill().addTo(content);
        const endX = this.tips < 9 ? this.content.nativeElement.offsetWidth - this.tipWidth - 30 : 32 + this.tipWidth;
        const endY = 8 + ((this.tipHight / 2) + (this.tipHight + 10) * (count % 9));
        Tween.to(content, {y: 10 + (this.tipHight + 10) * (count % 9)}, {
            duration: 800,
            stagger: 20,
            // @ts-ignore
            ease: Ease.Bounce.EaseOut,
            onComplete: () => {
                this.createLine(pos, {endX, endY});
            }
        });
        content.addTo(this.tipsLayer);
        this.tips += 1;
        this.createShockWave(id, x, y);
    }
}
